import api from "./client";

/**
 * Body for POST /push/register — must match heric-back
 * `RegisterTokenRequest` (push_notification_schema.py) exactly.
 */
export interface RegisterTokenPayload {
  token: string;
  platform: "ios" | "android" | "web";
  device_id?: string;
  device_name?: string;
  app_version?: string;
  metadata?: Record<string, unknown>;
}

export const pushApi = {
  /** Register this device's FCM token so the backend can push notifications. */
  registerToken: async (
    payload: RegisterTokenPayload,
  ): Promise<{ token_id: string; message: string }> => {
    const { data } = await api.post("/push/register", payload);
    return data;
  },

  /** Remove an FCM token (e.g. when the user turns pop-ups off for this device). */
  unregisterToken: async (
    token: string,
  ): Promise<{ message: string; tokens_removed: number }> => {
    const { data } = await api.post("/push/unregister", { token });
    return data;
  },
};
